import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { Typography } from '@mui/material';

interface TimerProps {
  isPlaying: boolean;
  duration: number;
  onComplete: () => void;
  showCountdown: boolean;
}

const Timer = ({ isPlaying, duration, onComplete, showCountdown }: TimerProps) => (
  <CountdownCircleTimer
    size={30}
    strokeWidth={3}
    isPlaying={isPlaying}
    duration={duration}
    colors="#d7d7d7"
    trailColor="#f7f7f7"
    onComplete={onComplete}>
    {({ remainingTime }) => showCountdown && <Typography color="#a7a7a7">{remainingTime}</Typography>}
  </CountdownCircleTimer>
);

export default Timer;
